/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconDeviceUsb = createReactComponent("outline", "device-usb", "IconDeviceUsb", [["path", { "d": "M8 8h8v9a3 3 0 0 1 -3 3h-2a3 3 0 0 1 -3 -3v-9z", "key": "svg-0" }], ["path", { "d": "M10 8v-4h4v4", "key": "svg-1" }]]);

export { IconDeviceUsb as default };
//# sourceMappingURL=IconDeviceUsb.mjs.map
